import * as React from 'react';
import { BlockProps } from '../index.types';
import HeroComponent from 'components/success-stories/hero-block/hero-block';

type HeroBlockType = {
    block: BlockProps;
} & {
    alt?: string;
    title?: string;
    mediaType?: 'video' | 'image';
    mediaURL?: string;
    src?: string;
    aspectRatio?: number;
};

export default function HeroBlock({ block, ...props }: HeroBlockType) {
    const aspectRatio = props.aspectRatio ? props.aspectRatio : 211 / 375;
    if (props.src) {
        return (
            <HeroComponent
                title={props.title}
                type={props.src ? HeroComponent.type.videoIframe : HeroComponent.type.image}
                alt={props.alt}
                url={props.src}
                // for now only for main video from Bumble-Honey-Ambassadors
                aspectRatio={aspectRatio}
            />
        );
    }

    if (props.mediaURL) {
        return (
            <HeroComponent
                title={props.title}
                type={props.mediaType ? HeroComponent.type.video : HeroComponent.type.image}
                alt={props.alt}
                url={props.mediaURL}
                aspectRatio={aspectRatio}
            />
        );
    }

    return <p>No media file was found</p>;
}
